module.exports = __webpack_public_path__ + "img/gemerbarbier_priceList_phone.ce4837de.jpg";